// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BlockElec_wrapper__1ryl8"};